<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
        >
          <b-form-group
            label="Search"
            label-for="filter_search"
            label-class="font-weight-bold"
          >
            <b-input
              id="filter_search"
              v-model="tableProductCategories.filter"
              type="text"
              placeholder="search here"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            type="button"
            variant="success"
            @click="onShowAddForm"
          >
            Add Category
          </b-button>
        </b-col>
      </b-row>

      <b-table
        ref="tableProductCategories"
        hover
        responsive
        class="mt-2"
        :per-page="tableProductCategories.perPage"
        :current-page="tableProductCategories.currentPage"
        :items="myProvider"
        :fields="tableProductCategories.fields"
        :sort-by.sync="tableProductCategories.sortBy"
        :sort-desc.sync="tableProductCategories.sortDesc"
        :sort-direction="tableProductCategories.sortDirection"
        :filter="tableProductCategories.filter"
        :filter-included-fields="tableProductCategories.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{ tableProductCategories.currentPage * tableProductCategories.perPage - tableProductCategories.perPage + (data.index + 1) }}
        </template>

        <template #cell(active)="data">
          {{ data.item.active == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(action)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditForm(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableProductCategories.perPage"
              :options="tableProductCategories.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableProductCategories.currentPage"
            :total-rows="tableProductCategories.totalRows"
            :per-page="tableProductCategories.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-product-category"
      scrollable
      no-close-on-backdrop
      :title="ModalTitle"
      @ok="onValidateProductCategory"
    >
      <ValidationObserver
        ref="formProductCategory"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <ValidationProvider
            #default="{ errors }"
            name="category code"
            vid="category_code"
            rules="required|max:50"
          >
            <b-form-group
              label="Category Code"
              label-for="category_code"
              label-class="font-weight-bold"
            >
              <b-input
                id="category_code"
                v-model="category.category_code"
                type="text"
                placeholder="enter category code"
                autocomplete="off"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy || state.editing"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="category name"
            vid="category_name"
            rules="required|max:200"
          >
            <b-form-group
              label="Category Name"
              label-for="category_name"
              label-class="font-weight-bold"
            >
              <b-input
                id="category_name"
                v-model="category.category_name"
                type="text"
                placeholder="enter category name"
                autocomplete="off"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="type"
            vid="type"
            rules="required"
          >
            <b-form-group
              label="Type"
              label-for="type"
              label-class="font-weight-bold"
            >
              <b-form-select
                id="type"
                v-model="category.type"
                :options="list.types"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- select type --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            v-if="state.editing"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="category.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Is Active?
            </b-form-checkbox>
          </div>

        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>
<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AxiosError, AdminProductCategoryService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'AdminProductCategories',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Product Categories'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      list: {
        types: [
          { value: 'Aljay', text: 'Aljay Products' },
          { value: 'Allied', text: 'Allied Products' }
        ]
      },
      category: {
        id: null,
        category_code: null,
        category_name: null,
        type: null,
        active: 0
      },
      tableProductCategories: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          { key: 'index', class: 'text-center' },
          { key: 'action', class: 'text-center' },
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'category_code' },
          { key: 'category_name' },
          { key: 'active', label: 'IS ACTIVE?', class: 'text-center' },
          { key: 'updated_at', formatter: this.dateTimeFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    ModalTitle () {
      return this.state.editing ? 'Edit Category' : 'Add Category'
    }
  },

  mounted () {
    core.index()
  },

  methods: {

    async myProvider (ctx) {
      return await AdminProductCategoryService.get(
        this.objectToUrl({
          page: ctx.currentPage,
          per_page: ctx.perPage,
          sort: ctx.sortBy,
          sort_desc: ctx.sortDesc,
          filter_text: ctx.filter
        })
      ).then(({ data }) => {
        this.tableProductCategories.totalRows = data.total_rows
        return data.items
      }).catch(() => [])
    },

    onTableRefresh () {
      this.$refs.tableProductCategories.refresh()
    },

    onShowAddForm () {
      this.state.editing = false
      this.category.id = null
      this.category.category_code = null
      this.category.category_name = null
      this.category.type = null
      this.category.active = 1
      this.$bvModal.show('modal-product-category')
    },

    onShowEditForm (productCategory) {
      this.state.editing = true
      this.category.id = productCategory.id
      this.category.category_code = productCategory.category_code
      this.category.category_name = productCategory.category_name
      this.category.type = productCategory.type
      this.category.active = productCategory.active
      this.$bvModal.show('modal-product-category')
    },

    async onValidateProductCategory (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.formProductCategory.validate().then(async isAllFieldsValid => {
        if (isAllFieldsValid) {
          let text = 'Do you really want to create category?'
          if (this.state.editing) {
            text = 'Do you really want to save changes?'
          }
          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: text,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.state.busy = true
              if (this.state.editing) {
                return this.onPutProductCategory()
              }

              return this.onPostProductCategory()
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk('Oops! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            centered: true
          })
        }
      })
    },

    async onPostProductCategory () {
      return new Promise(resolve => {
        AdminProductCategoryService.post(this.category).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-product-category')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.onTableRefresh()
          })
        }).catch(error => {
          this.state.busy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.formProductCategory.setErrors(error.message)
              resolve(error)
            }
          }
        })
      })
    },

    async onPutProductCategory () {
      return new Promise(resolve => {
        AdminProductCategoryService.put(this.category).then(({ data }) => {
          this.$bvModal.hide('modal-product-category')
          this.state.busy = false
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.tableProductCategories.localItems, { id: data.productCategory.id })
            row.created_at = data.productCategory.created_at
            row.category_code = data.productCategory.category_code
            row.category_name = data.productCategory.category_name
            row.type = data.productCategory.type
            row.active = data.productCategory.active
            row.updated_at = data.productCategory.updated_at
          })
        }).catch(error => {
          this.state.busy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.formProductCategory.setErrors(error.message)
              resolve(error)
            }
          }
        })
      })
    }
  }
}
</script>
